/**
 * Upload Configuration Utility
 * Determines the correct upload endpoint based on environment
 */

export function getUploadUrl() {
  // Check if running locally (development)
  const isLocalhost = window.location.hostname === 'localhost' || 
                      window.location.hostname === '127.0.0.1' ||
                      window.location.hostname.startsWith('192.168.');
  
  if (isLocalhost) {
    // Development: use local dev-server /upload endpoint
    return `http://${window.location.hostname}:${window.location.port || 8000}/upload`;
  } else {
    // Production: use Vercel's local /api/upload endpoint (Vercel routes to api/upload.js)
    return '/api/upload';
  }
}

export function buildUploadEndpoint(guideSlug) {
  const baseUrl = getUploadUrl();
  return `${baseUrl}?guideSlug=${encodeURIComponent(guideSlug)}`;
}
